// AgreementModal.jsx - Componente principal
import ViewAgreement from './ViewAgreementComponent';
import EditAgreement from './EditAgreementComponent';

const AgreementModal = ({ agreement, open, onClose, mode, onUpdate,setIsSubmitting }) => {

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-auto">
          {mode === 'edit' ? (
            <EditAgreement 
              agreement={agreement}
              onClose={onClose}
              onUpdate={onUpdate}
              setIsSubmitting={setIsSubmitting}
            />
          ) : (
            <div className='w-full max-w-3xl mx-auto'>
                <ViewAgreement 
                agreement={agreement}
                onClose={onClose}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AgreementModal;